import React from "react";
import "./AboutUs.styles.scss";

const AboutUs = () => {
  return (
    <>
      <h3 className="about-us-heading">About Us</h3>
      <p className="about-us-text">
        Since 1938 we have powered the world's plants and machines with
        unmatched reliability and value. With over 10,000 types of bearing
        products look forward to meeting your expectations. We are marketing in
        solutions for critical applications in power plants, steel and metal
        industries, gearboxes, paper mills and other demanding applications
        within heavy industries.
      </p>
    </>
  );
};

export default AboutUs;
